import React from 'react'

import classNames from './CameraPicker.css'

export default function CameraPicker ({ addTerm, removeTerm, cameras, selected }) {
  function renderCamera (camera, label) {
    const index = selected.findIndex(c => c.value === camera)
    const active = index !== -1
    const onClick = () => {
      if (active) {
        removeTerm('camera', index)
      } else {
        addTerm('camera', camera, 'should')
      }
    }
    return (
      <button
        key={camera}
        className={active ? classNames.activeButton : classNames.button}
        onClick={onClick}>
        {label || camera}
      </button>
    )
  }

  return (
    <div className={classNames.picker}>
      {renderCamera('null', 'No Camera')}
      {cameras.map(camera => renderCamera(camera))}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/search/CameraPicker.js